// PRD 13 §2.2 #7 / §4.1 — audience (대상) badge.
//   PATIENT → blue  (badge-info)
//   STAFF   → gray outline (badge-outline)
//   BOTH    → purple (no purple badge class — inline per prototype)

import { useTranslation } from 'react-i18next';

import type { NoticeAudience } from '../types/notices.types';

interface NoticeAudienceBadgeProps {
  audience: NoticeAudience;
}

export function NoticeAudienceBadge({ audience }: NoticeAudienceBadgeProps) {
  const { t } = useTranslation('notices');
  const label = t(`audiences.${audience}`);

  if (audience === 'BOTH') {
    return (
      <span className="badge" style={{ background: '#EEEBFF', color: '#6D28D9' }}>
        {label}
      </span>
    );
  }
  if (audience === 'STAFF') {
    return <span className="badge badge-outline">{label}</span>;
  }
  return <span className="badge badge-info">{label}</span>;
}
